import { createSelector } from 'reselect';

export const selectLoading = createSelector(
  (state) => state.getIn(['solutionAssignments', 'loading']),
  (loading) => loading,
);

export const selectSolutionAssignments = createSelector(
  (state) => state.getIn(['solutionAssignments', 'data']),
  (data) => data.toJS(),
);
